import React from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { addEnquiryTender } from "../../services/enquiry-tender-service";
import { formatDateYYYY_MM_DD } from "../../functions/common-functions";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { ALERT_PARAMS } from "../../utils/constant.js";

const UpdateDueDateModal = ({ show, onHide, selectedDate, setSelectedDate, selectedRows, setSelectedRows, setReload, reload, setLoading, loading, }) => {
    const MySwal = withReactContent(Swal);

    const handleDateBlur = (e) => {
        const { value } = e.target;
        const today = formatDateYYYY_MM_DD(new Date());
        if (value && value < today) {
            MySwal.fire({
                text: "Please select today's date or future date",
                imageUrl: errorImage,
                customClass: "swal-error",
            });
            setSelectedDate("");
        }
    };

    const handleUpdate = async () => {
        if (!selectedDate) {
            MySwal.fire({
                text: "Please select a date",
                imageUrl: errorImage,
                customClass: "swal-success"
            });
            return;
        }
        try {
            MySwal.fire({
                text: "Are you sure, do you want to update the due date?",
                confirmButtonText: "Update",
                title: "Update Due Date",
                ...ALERT_PARAMS,
            }).then(async (result2) => {
                if (result2.isConfirmed) {
                    setLoading(true);
                    for (const row of selectedRows) {
                        let status = row.EnquiryStatus;
                        if (!row.LinkedBPName) {
                            status = "Not Assigned";
                        }
                        const updatedRow = {
                            ...row,
                            DueDate: selectedDate,
                            EnquiryStatus: status,
                            MailStatus: "Pending",
                            DueDateFlag : status=== "Live" ? "Active" : "Inactive",
                        };
                        await addEnquiryTender(updatedRow);
                    }
                    setLoading(false);
                    MySwal.fire({
                        text: "Due dates updated successfully",
                        imageUrl: successImage,
                        customClass: "swal-success"
                    });
                    setReload(!reload);
                    onHide();
                    setSelectedDate(null);
                    setSelectedRows([]);
                }
            });
        } catch (error) {
            setLoading(false);
            MySwal.fire({
                text: "Failed to update due dates",
                imageUrl: errorImage,
                customClass: "swal-success"
            });
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="sm" backdrop="static">
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal.Header closeButton>
                <Modal.Title>Update Due Date</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="g-input">
                    <Form.Control
                        id="DueDate"
                        type="date"
                        name="DueDate"
                        placeholder=" "
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        onBlur={handleDateBlur}
                        min={formatDateYYYY_MM_DD(new Date())}
                    />
                    <Form.Label htmlFor="DueDate">Due Date</Form.Label>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="swal2-styled swal2-deny"
                    variant="secondary"
                    onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    variant="success"
                    className="btn-add-color semiBoldToggleButton rightAlignedButton"
                    onClick={handleUpdate}>
                    Update
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UpdateDueDateModal;
